import { MINUTE, HOUR, DAY } from '../Helpers/time'

/**
 * Formats a timestamp for chat list preview.
 * "Щойно" / "5 хв тому" / "2 год тому" / "Вчора" / "дд.мм.рр"
 */
export function formatRelativeTime(timestamp: number): string {
  const now = Date.now()
  const diff = now - timestamp

  if (diff < MINUTE) return 'Щойно'
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)} хв тому`
  if (diff < 2 * HOUR) return '1 год тому'
  if (diff < DAY) return `${Math.floor(diff / HOUR)} год тому`

  const todayStart = new Date(now)
  todayStart.setHours(0, 0, 0, 0)
  const yesterdayStart = new Date(todayStart.getTime() - DAY)

  if (timestamp >= yesterdayStart.getTime() && timestamp < todayStart.getTime()) return 'Вчора'

  const date = new Date(timestamp)

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear()).slice(-2)
  return `${day}.${month}.${year}`
}

/**
 * Formats a timestamp for message bubble. "HH:MM"
 */
export function formatMessageTime(timestamp: number): string {
  const date = new Date(timestamp)
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${hours}:${minutes}`
}

/**
 * Formats lastSeen for user status. "був(ла) 5 хв тому" / "був(ла) вчора"
 */
export function formatLastSeen(timestamp: number): string {
  const relative = formatRelativeTime(timestamp)
  if (relative === 'Щойно') return 'щойно в мережі'
  return `був(ла) ${relative.toLowerCase()}`
}
